/**
 * ResultadoNumericoField — Decimal number input with client-side validation.
 *
 * Requirements: 3.1, 3.7
 */

import { useTranslation } from "react-i18next";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ResultadoNumericoFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  unidad?: string;
}

export function ResultadoNumericoField({
  value,
  onChange,
  error,
  unidad,
}: ResultadoNumericoFieldProps) {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    // Allow empty, digits, decimal point, and negative sign
    if (val === "" || /^-?\d*\.?\d*$/.test(val)) {
      onChange(val);
    }
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="valor_numerico">
        {t("procesamiento.captura.valor_numerico")}
        {unidad && <span className="ml-1 text-muted-foreground font-normal">({unidad})</span>}
      </Label>
      <Input
        id="valor_numerico"
        type="text"
        inputMode="decimal"
        placeholder={t("procesamiento.captura.valor_numerico_placeholder")}
        value={value}
        onChange={handleChange}
        className={error ? "border-destructive" : ""}
        autoFocus
      />
      {error && <p className="text-xs text-destructive">{error}</p>}
    </div>
  );
}
